import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  	actionIndex:"1",
  	user:{},
    token:""
  },
  getters: {
  	getActiveIndex: state => state.actionIndex,
  	getUserInfo: state => state.user,
    getToken: state => state.token
  },
  mutations: {
  	setActiveIndex(state,i){
  		state.actionIndex = i
  	},
  	setUserInfo(state,user){
  		state.user = user
  	},
    setToken(state,token){
      state.token = token
    },
    resetState (state) {
      Object.assign(state, JSON.parse(localStorage.getItem('store')))
    }
  },
  actions: {},
  modules: {},
  plugins: [
    store =>{
      store.subscribe((mutation, state) =>{
        localStorage.setItem('store', JSON.stringify(state))
      })
    }
  ]

});
